import { ethers } from 'ethers';
import { useWeb3 } from '../context/Web3Context';
import config from '../config/network';
import MatrixABI from '../abi/ClusterMatrix.json';

export function useMatrix() {
  const { provider } = useWeb3();

  function getMatrixRead() {
    if (!provider) return null;
    return new ethers.Contract(config.contracts.matrix, MatrixABI, provider);
  }

  async function getUserBoard(uid, packageId) {
    try {
      const matrix = getMatrixRead();
      if (!matrix) return null;
      const b = await matrix.getUserBoard(uid, packageId);
      return {
        currentReferrer: b.currentReferrer.toString(),
        firstLevel: [b.firstLevel[0].toString(), b.firstLevel[1].toString()],
        secondLevel: b.secondLevel.map(s => s.toString()),
        blocked: b.blocked,
        reinvestCount: b.reinvestCount.toString(),
      };
    } catch {
      return null;
    }
  }

  async function getBoardCycleCount(uid, packageId) {
    try {
      const matrix = getMatrixRead();
      if (!matrix) return '0';
      const c = await matrix.getBoardCycleCount(uid, packageId);
      return c.toString();
    } catch {
      return '0';
    }
  }

  async function getBoardCycleHistory(uid, packageId) {
    try {
      const matrix = getMatrixRead();
      if (!matrix) return [];
      const history = await matrix.getBoardCycleHistory(uid, packageId);
      return history.map(h => ({
        cycleNumber: h.cycleNumber.toString(),
        firstLevelUsers: [h.firstLevelUsers[0].toString(), h.firstLevelUsers[1].toString()],
        secondLevelUsers: h.secondLevelUsers.map(s => s.toString()),
        completedAt: h.completedAt.toString(),
      }));
    } catch {
      return [];
    }
  }

  async function getAllBoardsForUser(uid) {
    const boards = [];
    for (let i = 0; i < 7; i++) {
      const board = await getUserBoard(uid, i);
      const cycles = await getBoardCycleCount(uid, i);
      boards.push({ packageId: i, board, cycles });
    }
    return boards;
  }

  return { getUserBoard, getBoardCycleCount, getBoardCycleHistory, getAllBoardsForUser };
}
